import "../CodeSample.css";
import { jsx, jsxs } from "react/jsx-runtime";
import ClipboardButton from "./ClipboardButton.js";
const base = "CodeSample_base_4803d";
const commandContainer = "CodeSample_commandContainer_4803d";
const codeSample = "CodeSample_codeSample_4803d";
const css = {
  base,
  commandContainer,
  codeSample
};
const CodeSample = ({ text }) => {
  return /* @__PURE__ */ jsx("div", { className: css.base, children: /* @__PURE__ */ jsxs("div", { className: css.commandContainer, children: [
    /* @__PURE__ */ jsx("code", { className: css.codeSample, children: text }),
    /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(ClipboardButton, { getContent: () => text }) })
  ] }) });
};
export {
  CodeSample as default
};
